/* tslint:disable */
/* eslint-disable */
/**
 * openapi.yml
 * オンラインCE API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResultCe
 */
export interface ResultCe {
    /**
     * 日時
     * @type {string}
     * @memberof ResultCe
     */
    calculationDt?: string;
    /**
     * 電解電流
     * @type {number}
     * @memberof ResultCe
     */
    electrolyticCurrent?: number;
    /**
     * 電解電流（計算用）
     * @type {number}
     * @memberof ResultCe
     */
    electrolyticCurrentTemp?: number;
    /**
     * 苛性温度
     * @type {number}
     * @memberof ResultCe
     */
    causticTemperature?: number;
    /**
     * 塩水出口ＰＨ
     * @type {number}
     * @memberof ResultCe
     */
    saltWaterOutletPh?: number;
    /**
     * 塩素ガス圧力
     * @type {number}
     * @memberof ResultCe
     */
    chGasPressure?: number;
    /**
     * 塩酸流量
     * @type {number}
     * @memberof ResultCe
     */
    hclFlowRate?: number;
    /**
     * 塩水流量
     * @type {number}
     * @memberof ResultCe
     */
    salWaterFlow?: number;
    /**
     * 塩酸濃度
     * @type {number}
     * @memberof ResultCe
     */
    hclConcentration?: number;
    /**
     * SO4濃度
     * @type {number}
     * @memberof ResultCe
     */
    so4Concentration?: number;
    /**
     * SO4係数
     * @type {number}
     * @memberof ResultCe
     */
    so4ConcentrationCalc?: number;
    /**
     * pH
     * @type {number}
     * @memberof ResultCe
     */
    ph?: number;
    /**
     * 電圧
     * @type {number}
     * @memberof ResultCe
     */
    voltage?: number;
    /**
     * 苛性濃度
     * @type {number}
     * @memberof ResultCe
     */
    causticConcentration?: number;
    /**
     * 対数
     * @type {number}
     * @memberof ResultCe
     */
    cells?: number;
    /**
     * 途中計算：CEHCl
     * @type {number}
     * @memberof ResultCe
     */
    ceHcl?: number;
    /**
     * 途中計算：CEO2
     * @type {number}
     * @memberof ResultCe
     */
    ceO2?: number;
    /**
     * 途中計算：CEHCLO
     * @type {number}
     * @memberof ResultCe
     */
    ceHclo?: number;
    /**
     * 途中計算：CECLO3
     * @type {number}
     * @memberof ResultCe
     */
    ceClo3?: number;
    /**
     * CE
     * @type {number}
     * @memberof ResultCe
     */
    ce?: number;
    /**
     * 時間平均１
     * @type {number}
     * @memberof ResultCe
     */
    ceAvg1?: number;
    /**
     * 時間平均2
     * @type {number}
     * @memberof ResultCe
     */
    ceAvg2?: number;
    /**
     * 時間平均3
     * @type {number}
     * @memberof ResultCe
     */
    ceAvg3?: number;
    /**
     * 時間平均4
     * @type {number}
     * @memberof ResultCe
     */
    ceAvg4?: number;
}

/**
 * Check if a given object implements the ResultCe interface.
 */
export function instanceOfResultCe(value: object): value is ResultCe {
    return true;
}

export function ResultCeFromJSON(json: any): ResultCe {
    return ResultCeFromJSONTyped(json, false);
}

export function ResultCeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultCe {
    if (json == null) {
        return json;
    }
    return {
        
        'calculationDt': json['calculationDt'] == null ? undefined : json['calculationDt'],
        'electrolyticCurrent': json['electrolyticCurrent'] == null ? undefined : json['electrolyticCurrent'],
        'electrolyticCurrentTemp': json['electrolyticCurrentTemp'] == null ? undefined : json['electrolyticCurrentTemp'],
        'causticTemperature': json['causticTemperature'] == null ? undefined : json['causticTemperature'],
        'saltWaterOutletPh': json['saltWaterOutletPh'] == null ? undefined : json['saltWaterOutletPh'],
        'chGasPressure': json['chGasPressure'] == null ? undefined : json['chGasPressure'],
        'hclFlowRate': json['hclFlowRate'] == null ? undefined : json['hclFlowRate'],
        'salWaterFlow': json['salWaterFlow'] == null ? undefined : json['salWaterFlow'],
        'hclConcentration': json['hclConcentration'] == null ? undefined : json['hclConcentration'],
        'so4Concentration': json['so4Concentration'] == null ? undefined : json['so4Concentration'],
        'so4ConcentrationCalc': json['so4ConcentrationCalc'] == null ? undefined : json['so4ConcentrationCalc'],
        'ph': json['ph'] == null ? undefined : json['ph'],
        'voltage': json['voltage'] == null ? undefined : json['voltage'],
        'causticConcentration': json['causticConcentration'] == null ? undefined : json['causticConcentration'],
        'cells': json['cells'] == null ? undefined : json['cells'],
        'ceHcl': json['ceHcl'] == null ? undefined : json['ceHcl'],
        'ceO2': json['ceO2'] == null ? undefined : json['ceO2'],
        'ceHclo': json['ceHclo'] == null ? undefined : json['ceHclo'],
        'ceClo3': json['ceClo3'] == null ? undefined : json['ceClo3'],
        'ce': json['ce'] == null ? undefined : json['ce'],
        'ceAvg1': json['ceAvg1'] == null ? undefined : json['ceAvg1'],
        'ceAvg2': json['ceAvg2'] == null ? undefined : json['ceAvg2'],
        'ceAvg3': json['ceAvg3'] == null ? undefined : json['ceAvg3'],
        'ceAvg4': json['ceAvg4'] == null ? undefined : json['ceAvg4'],
    };
}

export function ResultCeToJSON(value?: ResultCe | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'calculationDt': value['calculationDt'],
        'electrolyticCurrent': value['electrolyticCurrent'],
        'electrolyticCurrentTemp': value['electrolyticCurrentTemp'],
        'causticTemperature': value['causticTemperature'],
        'saltWaterOutletPh': value['saltWaterOutletPh'],
        'chGasPressure': value['chGasPressure'],
        'hclFlowRate': value['hclFlowRate'],
        'salWaterFlow': value['salWaterFlow'],
        'hclConcentration': value['hclConcentration'],
        'so4Concentration': value['so4Concentration'],
        'so4ConcentrationCalc': value['so4ConcentrationCalc'],
        'ph': value['ph'],
        'voltage': value['voltage'],
        'causticConcentration': value['causticConcentration'],
        'cells': value['cells'],
        'ceHcl': value['ceHcl'],
        'ceO2': value['ceO2'],
        'ceHclo': value['ceHclo'],
        'ceClo3': value['ceClo3'],
        'ce': value['ce'],
        'ceAvg1': value['ceAvg1'],
        'ceAvg2': value['ceAvg2'],
        'ceAvg3': value['ceAvg3'],
        'ceAvg4': value['ceAvg4'],
    };
}

